import React from 'react';
import image3 from "../../../asset/Image3.jpeg"
const Vision = () => {
  return (
    <section id="vision" className="mb-5 vision">
      <h2 className="heading">Vision</h2>
      <img src={image3} className=''/>
      <p>
        To create an inclusive society where every individual and family can thrive, with equal access to opportunities,
        resources, and support – regardless of their background, circumstances, or abilities.
      </p>
    </section>
  );
};

export default Vision;
